<template>
    <div class="ubication" @click.stop="$emit('click')">
        <div class="ubication__name">{{ locationName }}</div>
        <inline-svg v-if="icon" class="ubication__icon" :src="icon"></inline-svg>
        <div class="ubication__location">
            <p class="name">{{ location }}</p>
            <template v-if="weatherLoaded">
                <p class="weather">{{ weather }}</p>
                <p class="temperature">{{ $castMetric(temperature) }}º</p>
                <p class="temperatureMinMax">min. {{ $castMetric(min) }}º, max. {{ $castMetric(max) }}º</p>
            </template>
        </div>
        <div class="ubication__info">
            <!--<div class="scrollArea">
                <div class="ubication__installations">
                    <slot name="installations"></slot>
                </div>-->
            </div>
            <ui-IcoBtn :label="actionLabel" valueIco="add" @click="$emit('addInstallation')"></ui-IcoBtn>
        </div>
    </div>
</template>

<script>
    import ui_IcoBtn from './ui-IcoBtn.vue';

    export default {
        components: { ui_IcoBtn },
        name: 'ui-Ubication',
        props: {
            name: String,
            locationName: String,
            location: String,
            weatherLoaded: Boolean,
            weather: String,
            temperature: Number,
            min: Number,
            max: Number,
            icon: String,
            actionLabel: String,
        },
    };
</script>
